import React, { useState, useEffect } from 'react';
import { MDBContainer, MDBRow, MDBCol, MDBTypography } from 'mdb-react-ui-kit';
import '../styles/index.css';
import { useLanguage } from '../context/LanguageContext';

export default function Projects() {
    const { language } = useLanguage();

    return (
        <MDBContainer breakpoint="lg" style={{paddingTop: "5rem", paddingBottom: "5rem"}} id='service-container'>
            <MDBTypography style={{ fontWeight: "600" }} tag='div' className='display-6 pb-3 mb-3 border-bottom' data-aos="fade-up">
                {language === 'EN' 
                    ? 'Every environment has its system. We make sure it fits.' 
                    : 'Fiecare mediu are propriul sistem. Ne asigurăm că se potrivește.'}
            </MDBTypography>
            <MDBRow className='g-2' data-aos="fade-up" data-aos-duration='700' data-aos-delay="200">
 
                <MDBCol md='4'>
                    <div style={{paddingBottom: "0px"}} className='lead mb-0 p-3 pb-0 pt-0 col-service'>
                        <div style={{marginBottom: "8px"}}>
                            {language === 'EN' ? 'Residential Homes' : 'Locuințe rezidențiale'}
                        </div>
                        <div style={{marginBottom: "8px"}}>
                            {language === 'EN' ? 'Outdoor & Pool Systems' : 'Sisteme pentru exterior și piscine'}
                        </div>
                    </div>
                </MDBCol>
                <MDBCol md='4'>
                    <div className='lead mb-0 p-3 pb-0 pt-0 col-service'>
                        <div style={{marginBottom: "8px"}}>
                            {language === 'EN' ? 'Commercial & Office Spaces' : 'Spații comerciale și birouri'}
                        </div>
                        <div style={{marginBottom: "8px"}}>
                            {language === 'EN' ? 'Data Centers & Technical Spaces' : 'Centre de date și spații tehnice'}
                        </div>
                    </div>
                </MDBCol>
                <MDBCol md='4'>
                    <div className='lead mb-0 p-3 pb-0 pt-0 col-service'>
                        <div style={{marginBottom: "8px"}}>
                            {language === 'EN' ? 'Industrial Facilities' : 'Facilități industriale'}
                        </div>
                        <div style={{marginBottom: "8px"}}>
                            {language === 'EN' ? 'Warehouses & Storage Facilities' : 'Depozite și spații de stocare'}
                        </div>
                    </div>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    );
}